export const initialState = {
  loadingStatus: {
    timeSlotLoading: false,
    holdBookingSlotLoading: false,
    releaseBookingSlotLoading: false,
    bookAppointmentLoading: false,
    saveSelectedBookingSlotLoading: false,
    clearSelectedBookingSlotLoading: false,
  },
  timeSlotData: {},
  currentHoldingSlot: {},
  selectedBookingSlot: {},
  error: '',
};
